import Vue from 'vue'
import Vuex from 'vuex'
import cookie from 'js-cookie'
import config from '@/config'
import { RouterConfig } from '@/router'
import helper from '@/utils/helper'
import { getUserMenu } from '@/api/common'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userStatusHasLoaded: false,
    userInfo: {},
    // 用户菜单列表
    userMenus: RouterConfig,
    // 缓存页面组件集合
    aliveComponents: [],
    // 头部缓存导航页面
    navList: [],
    // 侧边栏是否收起
    sideBarCollapse: Boolean(cookie.get('__content_expanding') === '1'),
    // 用户被授权的接口
    userApi: [],
    // 用户被授权的其他类型权限点
    userOtherAuth: [],
    // 权限菜单加载状态
    loading: false
  },
  getters: {
    stationTypeMap(state) {
      return state.stationTypeList.reduce(
        (acc, item) => ({ ...acc, [item.type]: item.name }),
        {}
      )
    }
  },
  mutations: {
    pushAliveComponent(state, aliveComponent) {
      if (state.aliveComponents.includes(aliveComponent)) {
        state.aliveComponents = state.aliveComponents.filter(
          (item) => item !== aliveComponent
        )
        state.aliveComponents.push(aliveComponent)
        return
      }

      // 缓存组件超过最大限制数处理
      if (state.aliveComponents.length === config.MAX_ALIVE_COMPONENTS) {
        state.aliveComponents.shift()
      }

      state.aliveComponents.push(aliveComponent)
    },

    popAliveComponent(state, aliveComponent) {
      const index = state.aliveComponents.findIndex((item) => {
        return aliveComponent === item
      })
      if (index !== -1) {
        state.aliveComponents.splice(index, 1)
      }
    },

    resetAliveComponents(state, aliveComponents) {
      state.aliveComponents = []
    },

    // 推入缓存页面
    pushNavPage(state, page) {
      const index = state.navList.findIndex((item) => {
        return page.name === item.name
      })
      if (index === -1) {
        if (state.navList.length === config.MAX_NAV_LIST) {
          state.navList.shift()
        }
        state.navList.push(page)
      }
    },

    // 推出导航栏缓存页面
    popNavPage(state, page) {
      const index = state.navList.findIndex((item) => {
        return page.name === item.name
      })
      if (index !== -1) {
        if (state.navList.length === 1) {
          state.navList = []
        } else {
          state.navList.splice(index, 1)
        }
      }
    },

    // 清除全部缓存页面
    resetNavPage(state) {
      state.navList = []
    },

    closeSidebar(state) {
      state.sideBarCollapse = false
    },

    openSidebar(state) {
      state.sideBarCollapse = true
    },

    SET_USER_MENUS: (state, menus) => {
      state.userMenus = menus
    },

    SET_USER_INFO: (state, info) => {
      state.userInfo = info
    },

    SET_USER_STATUS_LOADED: (state) => {
      state.userStatusHasLoaded = true
    },

    SET_USER_API: (state, apiList) => {
      state.userApi = apiList
    },

    SET_USER_OTHER_AUTH: (state, auth) => {
      state.userOtherAuth = auth
    },

    SET_LOADING: (state, status) => {
      state.loading = status
    }
  },
  actions: {
    getUserStatus: ({ commit }) => {
      return new Promise((resolve, reject) => {
        // 设置加载状态为true
        commit('SET_LOADING', true)
        commit('SET_USER_MENUS', [])
        getUserMenu()
          .then((res) => {
            // 完成获取权限数据时设置loading为false
            commit('SET_LOADING', false)
            if (res) {
              commit('SET_USER_INFO', res.sysUser)
              commit(
                'SET_USER_API',
                res.menus?.filter((item) => {
                  return item.type === 2
                })
              )
              commit(
                'SET_USER_OTHER_AUTH',
                res.menus?.filter((item) => {
                  return item.type === 3
                })
              )

              // 根据后端返回的权限数据过滤路由配置
              // 只保留那些在后端返回的type==1的页面中，path与路由name匹配的路由
              const authorizedPagePaths =
                res.menus
                  ?.filter((item) => item.type === 1)
                  ?.map((item) => item.path) || []

              // 递归过滤路由配置
              const filterRoutes = (routes) => {
                return routes.filter((route) => {
                  // 如果是页面路由，检查name是否在授权列表中
                  if (!route.children || route.children.length === 0) {
                    return authorizedPagePaths.includes(route.name)
                  } else {
                    // 如果有子路由，递归过滤子路由
                    route.children = filterRoutes(route.children)
                    // 只有当子路由过滤后还有内容时，才保留父路由
                    return route.children.length > 0
                  }
                })
              }

              let userMenus = filterRoutes(RouterConfig)
              console.log('userMenus', userMenus)
              if (userMenus.length > 0) {
                userMenus[0].redirect = helper.getRedirectPath(userMenus)

                commit('SET_USER_STATUS_LOADED')
                commit('SET_USER_MENUS', userMenus)
              }
              resolve(userMenus)
            } else {
              reject(res)
            }
          })
          .catch((err) => {
            // 发生错误时也需要设置loading为false
            commit('SET_LOADING', false)
            reject(err)
          })
      })
    }
  }
})
